import promise from 'bluebird'

import { bookingConstants } from '../_constants';

import { bookingService } from "../_services";

import { ResponseFilter } from "../config/response-handler";
import {productConstants} from "../_constants/productConstants";

export const bookingActions = {
    createEvent,

    getHairdresserBooking,
    getBookingByIdV2,
    hairdresserCancelBooking,
    hairdresserNewBookingStaff,
    hairdresserNewBookingClient,
    hairdresserNewBookingService,
    createNewCheckoutBooking,
    hairdresserNewBookingData,
    selectHairdresserBookingDate,
    selectHairdresserBookingTime,
    clientBookingSlots,
    editCheckoutBooking,
    userBookingState,
    updateBookingInfo,
    editProductServiceBooking,
    completeBookingStatus,
    editDairyBooking,
    noShowBooking,
    userCancelBooking,
    previewCancellationFee,
    checkDateRangeAvailability,
    getAvailableSlots,
    createBookingV2,
    // New v2 client booking actions
    getClientUpcomingBookings,
    getClientPastBookings,
    getBookingSlotsV2,
    // Global new-booking panel (persists across routes + reload)
    openMinimisedBooking,
    setMinimisedBooking,
    updateMinimisedBookingSlot,
    closeMinimisedBooking,
};

/************************************** getHairdresserInfo ******************************************************/


function createNewCheckoutBooking(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            return bookingService.createNewCheckoutBooking(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                  return serverResponseData;
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };

}


function createBookingV2(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            bookingService.createBookingV2(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                })
        })
    };
    function request(userCreateBookingRequest) { return { type: bookingConstants.USER_CREATE_BOOKING_REQUEST, userCreateBookingRequest } }
    function success(userCreateBookingSuccess) { return { type: bookingConstants.USER_CREATE_BOOKING_SUCCESS, userCreateBookingSuccess } }
    function failure(userCreateBookingFail) { return { type: bookingConstants.USER_CREATE_BOOKING_ERROR, userCreateBookingFail } }
}

function editCheckoutBooking(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            return bookingService.editCheckoutBooking(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                  return serverResponseData;
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };

}


function editProductServiceBooking(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            return bookingService.editProductServiceBooking(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                  return serverResponseData;
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };

}


// CHECKOUT_NEW_BOOKING

function createEvent(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            bookingService.createEvent(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(userCreateEventRequest) { return { type: bookingConstants.USER_CREATE_EVENT_REQUEST, userCreateEventRequest } }
    function success(userCreateEventSuccess) { return { type: bookingConstants.USER_CREATE_EVENT_SUCCESS, userCreateEventSuccess } }
    function failure(userCreateEventFail) { return { type: bookingConstants.USER_CREATE_EVENT_ERROR, userCreateEventFail } }
}


function getHairdresserBooking(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            dispatch(request(params));
            bookingService.getHairdresserBooking(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    //console.log("serverResponseData", serverResponseData);
                    dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                })
        })
    };
    function request(hairdresserBookingRequest) { return { type: bookingConstants.HAIRDRESSER_BOOKING_REQUEST, hairdresserBookingRequest } }
    function success(hairdresserBookingSuccess) { return { type: bookingConstants.HAIRDRESSER_BOOKING_SUCCESS, hairdresserBookingSuccess } }
    function failure(hairdresserBookingFail) { return { type: bookingConstants.HAIRDRESSER_BOOKING_ERROR, hairdresserBookingFail } }
}

function getBookingByIdV2(bookingId) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(bookingId));
            bookingService.getBookingByIdV2(bookingId)
                .then(response => {
                    const booking = response.data.responseData;
                    // Map v2 response to legacy-compatible shape
                    const mappedBooking = {
                        ...booking,
                        // Legacy uses .user, v2 uses .clientInfo
                        user: booking.clientInfo,
                        userId: booking.clientInfo?._id,
                        // Legacy uses .hairdresser with nested .hairdresser.hairdresser for profile data
                        hairdresser: booking.hairdresserInfo ? {
                            ...booking.hairdresserInfo,
                            hairdresser: booking.hairdresserInfo.hairdresser
                        } : null,
                        hairdresserId: booking.hairdresserInfo?._id,
                        // Client sharing restriction flags
                        clientDataRestricted: booking.clientDataRestricted || false,
                        restrictedByStaffName: booking.restrictedByStaffName || null,
                    };
                    // Wrap in legacy format for Redux store compatibility
                    const legacyShape = { data: { bookings: [mappedBooking] } };
                    resolve({ data: legacyShape });
                    dispatch(success(legacyShape.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                })
        })
    };
    function request(hairdresserBookingRequest) { return { type: bookingConstants.HAIRDRESSER_BOOKING_REQUEST, hairdresserBookingRequest } }
    function success(hairdresserBookingSuccess) { return { type: bookingConstants.HAIRDRESSER_BOOKING_SUCCESS, hairdresserBookingSuccess } }
    function failure(hairdresserBookingFail) { return { type: bookingConstants.HAIRDRESSER_BOOKING_ERROR, hairdresserBookingFail } }
}

function hairdresserCancelBooking(params) {
    //console.log("params",params)
    return function (dispatch) {

        return new promise(function (resolve, reject) {

            //dispatch(request(params));
            bookingService.hairdresserCancelBooking(params)
                .then(response => {
                    resolve(response);
                    // let { serverResponseData } = ResponseFilter(response);
                    // //console.log("serverResponseData", serverResponseData);
                    // dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    //dispatch(failure(err));

                })
        })
    };
    // function request(userBookingRequest) { return { type: bookingConstants.USER_BOOKING_REQUEST, userBookingRequest } }
    // function success(userBookingSuccess) { return { type: bookingConstants.USER_BOOKING_SUCCESS, userBookingSuccess } }
    // function failure(userBookingFail) { return { type: bookingConstants.USER_BOOKING_ERROR, userBookingFail } }
}


function editDairyBooking(params) {
 
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            bookingService.editDairyBooking(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}


//new node v2 api
function completeBookingStatus(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            bookingService.bookingComplete(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}


function noShowBooking(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            bookingService.noShowBooking(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}

// bookingComplete


function hairdresserNewBookingStaff(data){
    return function (dispatch) {
        dispatch({ type: bookingConstants.HAIRDRESSER_NEWBOOKING_SUCCESS, data })
    };
};

function hairdresserNewBookingClient(data){
    return function (dispatch) {
        dispatch({ type: bookingConstants.HAIRDRESSER_NEW_BOOKING_CLIENT, data })
    };
};

function hairdresserNewBookingService(data){
    return function (dispatch) {
        dispatch({ type: bookingConstants.HAIRDRESSER_NEW_BOOKING_SERVICE, data })
    };
};

function hairdresserNewBookingData(data){
    return function (dispatch) {
        dispatch({ type: bookingConstants.HAIRDRESSER_NEW_BOOKING_DATA, data })
    };
};

function selectHairdresserBookingDate(data){
    return function (dispatch) {
        dispatch({ type: bookingConstants.SELECT_HAIRDRESSER_BOOKING_DATE, data })
    };
};

function selectHairdresserBookingTime(data){
    return function (dispatch) {
        dispatch({ type: bookingConstants.SELECT_HAIRDRESSER_BOOKING_TIME, data })
    };
};

function clientBookingSlots(data){
    return function (dispatch) {
        dispatch({ type: bookingConstants.SELECT_CLIENT_BOOKING_SLOTS, data })
    };
};

function userBookingState(data){
    return function (dispatch) {
        dispatch({ type: bookingConstants.USER_SELECTED_SERVICE, data })
    };
};


function updateBookingInfo(data){
    return function (dispatch) {
        dispatch({ type: bookingConstants.UPDATE_BOOKING_INFO, data })
    };
};

function openMinimisedBooking(payload){
    return function (dispatch) {
        dispatch({ type: bookingConstants.MINIMISED_BOOKING_OPEN, payload });
    };
};

function setMinimisedBooking(isMinimised, draft){
    return function (dispatch) {
        dispatch({ type: bookingConstants.MINIMISED_BOOKING_SET_MINIMISED, payload: { isMinimised, draft } });
    };
};

function updateMinimisedBookingSlot(payload){
    return function (dispatch) {
        dispatch({ type: bookingConstants.MINIMISED_BOOKING_UPDATE_SLOT, payload });
    };
};

function closeMinimisedBooking(){
    return function (dispatch) {
        dispatch({ type: bookingConstants.MINIMISED_BOOKING_CLOSE });
    };
};


function userCancelBooking(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            bookingService.userCancelBooking(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}

function previewCancellationFee(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            bookingService.previewCancellationFee(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}

function checkDateRangeAvailability(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            bookingService.checkDateRangeAvailability(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                });
        });
    };
    function request(checkDateRangeAvailabilityRequest) { return { type: bookingConstants.CHECK_DATE_RANGE_AVAILABILITY_REQUEST, checkDateRangeAvailabilityRequest } }
    function success(checkDateRangeAvailabilitySuccess) { return { type: bookingConstants.CHECK_DATE_RANGE_AVAILABILITY_SUCCESS, checkDateRangeAvailabilitySuccess } }
    function failure(checkDateRangeAvailabilityFail) { return { type: bookingConstants.CHECK_DATE_RANGE_AVAILABILITY_ERROR, checkDateRangeAvailabilityFail } }
}

function getAvailableSlots(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            bookingService.getAvailableSlots(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                });
        });
    };
    function request(getAvailableSlotsRequest) { return { type: bookingConstants.GET_AVAILABLE_SLOTS_REQUEST, getAvailableSlotsRequest } }
    function success(getAvailableSlotsSuccess) { return { type: bookingConstants.GET_AVAILABLE_SLOTS_SUCCESS, getAvailableSlotsSuccess } }
    function failure(getAvailableSlotsFailure) { return { type: bookingConstants.GET_AVAILABLE_SLOTS_ERROR, getAvailableSlotsFailure } }
}

/**
 * Get client's upcoming bookings (v2 API)
 * @param {Object} params - Query parameters (skip, limit)
 * @returns {Function} Redux thunk action
 */
function getClientUpcomingBookings(params = {}) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            bookingService.getClientUpcomingBookings(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                });
        });
    };
    function request(getClientUpcomingBookingsRequest) { return { type: bookingConstants.GET_CLIENT_UPCOMING_BOOKINGS_REQUEST, getClientUpcomingBookingsRequest } }
    function success(getClientUpcomingBookingsSuccess) { return { type: bookingConstants.GET_CLIENT_UPCOMING_BOOKINGS_SUCCESS, getClientUpcomingBookingsSuccess } }
    function failure(getClientUpcomingBookingsFailure) { return { type: bookingConstants.GET_CLIENT_UPCOMING_BOOKINGS_ERROR, getClientUpcomingBookingsFailure } }
}

/**
 * Get client's past bookings (v2 API)
 * @param {Object} params - Query parameters (skip, limit)
 * @returns {Function} Redux thunk action
 */
function getClientPastBookings(params = {}) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request(params));
            bookingService.getClientPastBookings(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                });
        });
    };
    function request(getClientPastBookingsRequest) { return { type: bookingConstants.GET_CLIENT_PAST_BOOKINGS_REQUEST, getClientPastBookingsRequest } }
    function success(getClientPastBookingsSuccess) { return { type: bookingConstants.GET_CLIENT_PAST_BOOKINGS_SUCCESS, getClientPastBookingsSuccess } }
    function failure(getClientPastBookingsFailure) { return { type: bookingConstants.GET_CLIENT_PAST_BOOKINGS_ERROR, getClientPastBookingsFailure } }
}

function getBookingSlotsV2(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            bookingService.getBookingSlotsV2(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}

